<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'orderManagement',
})
</script>
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <router-view v-if="$route.name !== 'order'" />
  <div v-else class="order-page">
    <a-card>
      <div class="order-search">
        <a-form :model="state.tableData.param" class="global-search-form">
          <a-row :gutter="24">
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="订单编号">
                <a-input v-model:value="state.tableData.param.orderNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <!-- <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="展览名称">
                <a-input v-model:value="state.tableData.param.productName" placeholder="请输入展览名称" allow-clear />
              </a-form-item>
            </a-col> -->
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" class="mb-[10px]">
              <a-form-item label="订单状态">
                <a-select
                  v-model:value="state.tableData.param.orderStatus"
                  mode="multiple"
                  placeholder="请选择订单状态"
                  allow-clear
                  show-arrow
                  :show-search="enableOrderStatusSearch"
                  option-filter-prop="label"
                  :options="orderStatusSelectOptions"
                  max-tag-count="responsive"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="7" class="mb-[10px]">
              <a-form-item label="下单时间">
                <ant-picker v-model:value="state.dateRange" value-format="YYYY-MM-DD" :placeholder="['开始日期', '结束日期']"
                  style="width: 100%" :disabled-date="disabledDate" :allow-empty="[true, true]"
                  @calendar-change="onCalendarChange" @change="onDateChange" @openChange="onOpenChange" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="5" class="mb-[10px]">
              <div class="card-col-action flex flex-nowrap">
                <ant-button class="search mr-[10px]!" @click="getTableData" type="primary">
                  <SearchOutlined />查询
                </ant-button>
                <ant-button class="resetFun" @click="resetFun" type="primary">
                  <RedoOutlined />重置
                </ant-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <ant-table :columns="columns" :data-source="state.tableData.data" :loading="state.tableData.loading"
        :pagination="false" row-key="id">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">
            {{ (state.tableData.param.pageNum - 1) * state.tableData.param.pageSize + index + 1 }}
          </template>
          <template v-if="column.key === 'orderType'">
            {{ getOrderTypeText(record.orderType) }}
          </template>
          <template v-if="column.key === 'productName'">
            <span :title="record.productName">{{ record.productName }}</span>
          </template>
          <template v-if="column.key === 'userTel'">
            {{ record.userTel || '-' }}
          </template>
          <template v-if="column.key === 'orderTime'">
            <span class="order-time-cell">{{ record.orderTime }}</span>
          </template>
          <template v-if="column.key === 'status'">
            <span class="order-status-text">{{ record.orderStatusDesc || getStatusText(record.orderStatus) }}</span>
          </template>
          <template v-if="column.key === 'action'">
            <div class="table-action-left">
              <a-button type="link" size="small" @click="onDetail(record)">查看</a-button>
            </div>
          </template>
        </template>
      </ant-table>
      <ant-pagination v-model:current="state.tableData.param.pageNum" v-model:page-size="state.tableData.param.pageSize"
        :total="state.tableData.total" :page-size-options="['10', '20']" show-size-changer
        :show-total="(total) => `共 ${total} 条`" :showQuickJumper="true" @change="onPageChange"
        @show-size-change="onShowSizeChange" />
      <order-detail-dialog ref="detailDialogRef" />
    </a-card>
  </div>
</template>

<script setup lang="ts" name="orderManagement">
import { computed, reactive, ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons-vue'
import { useOrder } from '@/store/order/order'
import { useDictionary } from '@/store/system/dictionary'
import { fetchWithPaginationFallback } from '@/utils/paginationFallback'
import OrderDetailDialog from './detailDialog.vue'
import dayjs from 'dayjs'

const route = useRoute()
const orderStore = useOrder()
const dictionaryStore = useDictionary()
const detailDialogRef = ref()

// 暂时关闭订单状态搜索，需要时改为 true 即可按中文状态文字搜索
const enableOrderStatusSearch = false
const orderStatusOptions = ref<any[]>([])
const orderStatusSelectOptions = computed(() => {
  return orderStatusOptions.value.map((item) => ({
    label: item.name,
    value: item.code
  }))
})

const loadOrderStatusDict = async () => {
  try {
    const data: any = await dictionaryStore.getDict({ code: 'order_status' })
    orderStatusOptions.value = data || []
  } catch (e) {
    orderStatusOptions.value = []
  }
}

const columns = [
  { title: '序号', key: 'index', width: 70, align: 'center' },
  { title: '订单编号', dataIndex: 'orderNo', key: 'orderNo', ellipsis: true, align: 'center' },
  { title: '订单类型', dataIndex: 'orderType', key: 'orderType', width: 100, align: 'center' },
  { title: '展览名称', dataIndex: 'productName', key: 'productName', ellipsis: true, align: 'center' },
  { title: '用户昵称', dataIndex: 'userName', key: 'userName', ellipsis: true, align: 'center' },
  { title: '用户手机号', dataIndex: 'userTel', key: 'userTel', width: 130, align: 'center' },
  { title: '订单状态', key: 'status', width: 150, align: 'center' },
  { title: '下单时间', dataIndex: 'orderTime', key: 'orderTime', width: 180, align: 'center' },
  { title: '操作', key: 'action', width: 100, align: 'center' }
]

const state = reactive({
  dateRange: [] as (string | null)[],
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      pageNum: 1,
      pageSize: 10,
      orderNo: '',
      // productName: '',
      orderStatus: [] as Array<string | number>,
      startTime: '',
      endTime: ''
    }
  }
})
const dates = ref<any[]>([])

const onCalendarChange = (val: any[]) => {
  const newStart = val?.[0]
  const newEnd = val?.[1]

  if (!newStart && !newEnd) {
    dates.value = []
    return
  }

  if (dates.value.length === 2 && dates.value[0] && dates.value[1]) {
    const oldStart = String(dates.value[0])
    const oldEnd = String(dates.value[1])

    if ((!newStart || newStart === oldStart) && (!newEnd || newEnd === oldEnd)) {
      dates.value = [oldStart, oldEnd]
      return
    }

    const isStartChanged = !!(newStart && newStart !== oldStart)
    const isEndChanged = !!(newEnd && newEnd !== oldEnd)

    if (isStartChanged && !isEndChanged) {
      handleStartChange(newStart, oldEnd)
      return
    }

    if (!isStartChanged && isEndChanged) {
      handleEndChange(oldStart, newEnd)
      return
    }

    if (isStartChanged && isEndChanged) {
      const diffToStart = Math.abs(dayjs(newStart).diff(oldStart, 'days'))
      const diffToEnd = Math.abs(dayjs(newEnd).diff(oldEnd, 'days'))
      if (diffToStart <= diffToEnd) {
        handleStartChange(newStart, oldEnd)
      } else {
        handleEndChange(oldStart, newEnd)
      }
    }
    return
  }

  if (newStart && !newEnd) {
    dates.value = [newStart, undefined]
  } else if (!newStart && newEnd) {
    dates.value = [undefined, newEnd]
  } else if (newStart && newEnd) {
    dates.value = [newStart, newEnd]
  }
}

const handleStartChange = (newStart: string, oldEnd: string) => {
  const startDate = dayjs(newStart)
  const endDate = dayjs(oldEnd)
  const diffDays = endDate.diff(startDate, 'days')
  dates.value = [newStart, undefined]
  if (diffDays >= 0 && diffDays <= 365) {
    state.dateRange = [newStart, oldEnd]
  } else {
    state.dateRange = [newStart, null]
  }
}

const handleEndChange = (oldStart: string, newEnd: string) => {
  const startDate = dayjs(oldStart)
  const endDate = dayjs(newEnd)
  const diffDays = endDate.diff(startDate, 'days')
  dates.value = [undefined, newEnd]
  if (diffDays >= 0 && diffDays <= 365) {
    state.dateRange = [oldStart, newEnd]
  } else {
    state.dateRange = [null, newEnd]
  }
}

const onOpenChange = (open: boolean) => {
  if (open) {
    const [start, end] = state.dateRange
    if (start && end) {
      dates.value = [start, end]
    } else if (start) {
      dates.value = [start, undefined]
    } else if (end) {
      dates.value = [undefined, end]
    } else {
      dates.value = []
    }
  } else {
    validateDateRange()
  }
}

const onDateChange = (val: (string | null)[]) => {
  if (val && val.length === 2) {
    const [startStr, endStr] = val
    if (startStr && endStr) {
      const start = dayjs(startStr)
      const end = dayjs(endStr)
      const diffDays = end.diff(start, 'days')
      if (diffDays < 0 || diffDays > 365) {
        if (dates.value[0] && !dates.value[1]) {
          state.dateRange = [startStr, null]
          dates.value = [startStr, undefined]
        } else if (!dates.value[0] && dates.value[1]) {
          state.dateRange = [null, endStr]
          dates.value = [undefined, endStr]
        } else {
          state.dateRange = []
          dates.value = []
        }
        return
      }
      state.dateRange = [startStr, endStr]
      if (dates.value[0] && !dates.value[1]) {
        dates.value = [startStr, undefined]
      } else if (!dates.value[0] && dates.value[1]) {
        dates.value = [undefined, endStr]
      } else {
        dates.value = [startStr, endStr]
      }
    } else if (startStr) {
      state.dateRange = [startStr, null]
      dates.value = [startStr, undefined]
    } else if (endStr) {
      state.dateRange = [null, endStr]
      dates.value = [undefined, endStr]
    } else {
      state.dateRange = []
      dates.value = []
    }
  }
}

const validateDateRange = () => {
  if (state.dateRange.length === 2 && state.dateRange[0] && state.dateRange[1]) {
    const start = dayjs(state.dateRange[0])
    const end = dayjs(state.dateRange[1])
    const diffDays = end.diff(start, 'days')
    if (diffDays < 0 || diffDays > 365) {
      const [startStr, endStr] = state.dateRange
      if (dates.value[0] && !dates.value[1]) {
        state.dateRange = [startStr, null]
        dates.value = [startStr, undefined]
      } else if (!dates.value[0] && dates.value[1]) {
        state.dateRange = [null, endStr]
        dates.value = [undefined, endStr]
      } else {
        state.dateRange = []
        dates.value = []
      }
      return true
    }
  }
  return true
}

const disabledDate = (current: any) => {
  if (!dates.value || dates.value.length === 0) return false
  const currentDate = dayjs(current)

  if (dates.value.length === 2 && dates.value[0] && dates.value[1]) {
    return false
  }

  if (dates.value[0] && !dates.value[1]) {
    const start = dayjs(dates.value[0])
    const diffDays = currentDate.diff(start, 'days')
    return diffDays < 0 || diffDays > 365
  }

  if (!dates.value[0] && dates.value[1]) {
    const end = dayjs(dates.value[1])
    const diffDays = end.diff(currentDate, 'days')
    return diffDays < 0 || diffDays > 365
  }

  return false
}

const getOrderTypeText = (type?: string) => {
  switch (type) {
    case 'ticket': return '门票'
    case 'goods': return '实物商品'
    default: return type || '-'
  }
}

const getStatusText = (status?: number) => {
  const option = orderStatusOptions.value.find((item) => String(item.code) === String(status))
  return option?.name || '未知'
}

const resetFun = () => {
  state.tableData.param.orderNo = ''
  // state.tableData.param.productName = ''
  state.tableData.param.orderStatus = []
  state.tableData.param.startTime = ''
  state.tableData.param.endTime = ''
  state.tableData.param.pageNum = 1
  state.dateRange = []
  dates.value = []
  getTableData()
}

const getTableData = async () => {
  validateDateRange()
  if (state.dateRange.length === 2 && state.dateRange[0] && state.dateRange[1]) {
    state.tableData.param.startTime = state.dateRange[0]
    state.tableData.param.endTime = state.dateRange[1]
  } else {
    state.tableData.param.startTime = ''
    state.tableData.param.endTime = ''
  }
  state.tableData.loading = true
  try {
    const requestParam = {
      ...state.tableData.param,
      orderStatus: state.tableData.param.orderStatus.length
        ? state.tableData.param.orderStatus.join(',')
        : undefined
    }
    const data: any = await fetchWithPaginationFallback(
      (param) => orderStore.getOrderPage(param),
      requestParam
    )
    state.tableData.data = data.records || []
    state.tableData.total = data.total || 0
    state.tableData.param.pageNum = data.pageNum ?? state.tableData.param.pageNum
  } finally {
    state.tableData.loading = false
  }
}

const onDetail = (record: any) => {
  detailDialogRef.value?.openDialog(record, orderStatusOptions.value)
}

const onPageChange = (page: number) => {
  state.tableData.param.pageNum = page
  getTableData()
}

const onShowSizeChange = (_current: number, size: number) => {
  state.tableData.param.pageSize = size
  state.tableData.param.pageNum = 1
  getTableData()
}

onMounted(() => {
  loadOrderStatusDict()
  getTableData()
})

watch(
  () => route.name,
  (name) => {
    if (name === 'order') {
      getTableData()
    }
  }
)
</script>

<style scoped lang="less">
.order-status-text {
  color: #5c5757;
}
</style>
